const $inject = ['$q', '$http', 'APP_CONFIG'];

const citySearchService = function ($q, $http, APP_CONFIG) {
  var service = {};

  service.get = get;

  function get (params) {
    let deferred = $q.defer();
    let url = APP_CONFIG.api.citySearch;

    $http.get(url, { params: params })
      .then((response)=>{
        response.data.forEach(city => {
          city.Airports.map(airport => {
            airport.Label = `${airport.Name} (${airport.Value})`
            return airport;
          });
          city.cityCountry = city.City + ':' + city.Country;
          city.label = city.City + ' (' + city.Country + ')';
        });

        deferred.resolve(response.data);
      }).catch(err => {
        deferred.reject(err);
    });

    return deferred.promise;
  }

  return service;
};

citySearchService.$inject = $inject;

export default citySearchService;



// WEBPACK FOOTER //
// ./src/services/citySearchService.js